import type { ProductLookup } from '@/types'

import { useEffect, useRef, useState } from 'react'
import { useCart } from '@/lib/cart'
import { apiRequest } from '@/lib/fetcher'

export const useCartSync = (enabled = true): { syncing: boolean, synced: boolean } => {
    const { items, hydrated, syncProducts } = useCart()
    const [syncing, setSyncing] = useState(false)
    const [synced, setSynced] = useState(false)
    const lastKey = useRef('')
    const ids = Array.from(new Set(items.map(item => item.productId))).sort().join(',')

    useEffect(() => {
        if (!enabled || !hydrated) return

        if (!ids) {
            setSynced(true)

            return
        }

        if (lastKey.current === ids) return

        let cancelled = false

        setSyncing(true)

        apiRequest<{ products: Array<ProductLookup> }>(`/api/products/lookup?ids=${encodeURIComponent(ids)}`)
            .then(data => {
                if (cancelled) return

                lastKey.current = ids
                syncProducts(data.products)
            })
            .catch(() => undefined)
            .finally(() => {
                if (cancelled) return

                setSyncing(false)
                setSynced(true)
            })

        return () => {
            cancelled = true
        }
    }, [enabled, hydrated, ids, syncProducts])

    return { syncing, synced }
}
